import { Media } from '@onclicks/sharedcomponents/Media/Media'
import { Media as MediaType } from '@/payload-types'
import Link from 'next/link'
import { cn } from '@/utilities/ui'

export const Logo = ({
  logo,
  className,
  imgClassName,
}: {
  logo: number | MediaType | null | undefined
  className?: string
  imgClassName?: string
}) => {
  return (
    <Link href="/" className={className}>
      <Media resource={logo} imgClassName={cn(`w-48 shrink-0`, imgClassName)} />
    </Link>
  )
}
